import { useIntl } from "react-intl";
import type { BookingInterface } from "types/booking";
import { SUBCATEGORY_TO_CATEGORY } from "types/subCategory";

export const useServiceTitle = (booking: BookingInterface | undefined): string => {
    const intl = useIntl();

    if (!booking?.category || !booking?.subcategory) {
        return "";
    }

    const category = String(booking.category).toLowerCase();
    const subcategory = String(booking.subcategory).toLowerCase();
    const mappedCategory = SUBCATEGORY_TO_CATEGORY[booking.subcategory];

    if (mappedCategory) {
        const subcategoryMessageId = `subcategory.${mappedCategory.toLowerCase()}.${subcategory}.label`;

        if (subcategoryMessageId in intl.messages) {
            return String(intl.formatMessage({ id: subcategoryMessageId }));
        }
    }

    const categoryMessageId = `category.${category}`;

    if (categoryMessageId in intl.messages) {
        return String(intl.formatMessage({ id: categoryMessageId }));
    }

    return category;
};
